import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _slicedToArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React, { useContext } from "react";
import { AppExperimentContext, SOURCE_TYPE_DEPARTMENT_CATEGORY_NAV } from "@catchoftheday/analytics";
import { GlobalContextProvider, MetaTags, MetaTitle, SponsoredDisclaimerModal } from "@catchoftheday/common-vendors";
import { getEnvConfig } from "@catchoftheday/env-config";
import { ServerGQLClient } from "@catchoftheday/graphql-utils";
import { DEPARTMENT_FEATURED_EVENTS_LIMIT } from "../../../../consts/index.js";
import { DepartmentDocument } from "../../../../generated/graphql.jsx";
import { DepartmentPageLayoutZone } from "../../../layouts/department/PageLayout.jsx";
import { CategoryGrid } from "../../../pure/department/CategoryGrid/CategoryGrid.jsx";
import { ConstructorRecommender } from "../../../pure/department/ConstructorRecommender/ConstructorRecommender.jsx";
import { EventGrid } from "../../../pure/department/EventGrid/EventGrid.jsx";
import { PageHeader } from "../../../pure/department/PageHeader/PageHeader.jsx";
import { SeoDescription } from "../../../pure/department/SeoDescription/SeoDescription.jsx";
import { SponsoredRecommender } from "../../../pure/department/SponsoredRecommender/SponsoredRecommender.jsx";
import { TopBrands } from "../../../pure/department/TopBrands/TopBrands.jsx";
import { jsx as ___EmotionJSX } from "@emotion/react";
var eventsLimit = DEPARTMENT_FEATURED_EVENTS_LIMIT;
export var BaseDepartmentContainer = function BaseDepartmentContainer(_ref) {
  var department = _ref.department,
      host = _ref.host;

  var _useContext = useContext(AppExperimentContext),
      getExperiments = _useContext.getExperiments;

  var _getExperiments = getExperiments(["department_page_recommendations_nov_24"]),
      _getExperiments$exper = _slicedToArray(_getExperiments.experiments, 1),
      departmentRecommenderExperiment = _getExperiments$exper[0];

  if (!(department !== null && department !== void 0 && department.id)) {
    return null;
  }

  var id = department.id,
      _department$meta = department.meta,
      title = _department$meta.title,
      description = _department$meta.description,
      header = department.header,
      name = department.name,
      slug = department.slug,
      categoryUrl = department.categoryUrl,
      events = department.events,
      topBrands = department.topBrands,
      categories = department.categories,
      htmlDescription = department.htmlDescription;
  var featuredEvents = events === null || events === void 0 ? void 0 : events.slice(0, eventsLimit);
  var remainingEvents = events === null || events === void 0 ? void 0 : events.slice(eventsLimit);
  return ___EmotionJSX(DepartmentPageLayoutZone, null, ___EmotionJSX(MetaTitle, {
    host: host
  }, title), ___EmotionJSX(MetaTags, {
    withHead: true,
    tags: [{
      name: "description",
      content: description
    }]
  }), ___EmotionJSX(PageHeader, _extends({
    name: name,
    slug: slug
  }, header)), ___EmotionJSX(CategoryGrid, {
    departmentSlug: slug,
    categories: categories,
    categoryUrl: "".concat(categoryUrl, "?st=").concat(SOURCE_TYPE_DEPARTMENT_CATEGORY_NAV)
  }), !!(featuredEvents !== null && featuredEvents !== void 0 && featuredEvents.length) && ___EmotionJSX(EventGrid, {
    events: featuredEvents
  }), topBrands.length > 0 && ___EmotionJSX(TopBrands, {
    departmentName: name,
    brands: topBrands
  }), (departmentRecommenderExperiment === null || departmentRecommenderExperiment === void 0 ? void 0 : departmentRecommenderExperiment.bucket) === 0 && ___EmotionJSX(SponsoredRecommender, {
    categorySlug: slug
  }), (departmentRecommenderExperiment === null || departmentRecommenderExperiment === void 0 ? void 0 : departmentRecommenderExperiment.bucket) === 1 && ___EmotionJSX(ConstructorRecommender, {
    departmentName: name,
    categoryId: id
  }), !!(remainingEvents !== null && remainingEvents !== void 0 && remainingEvents.length) && ___EmotionJSX(EventGrid, {
    events: remainingEvents
  }), htmlDescription && ___EmotionJSX(SeoDescription, {
    departmentName: name,
    description: htmlDescription
  }));
};
export var DepartmentContainer = function DepartmentContainer(props) {
  return ___EmotionJSX(GlobalContextProvider, null, ___EmotionJSX(SponsoredDisclaimerModal, null), ___EmotionJSX(BaseDepartmentContainer, props));
};
export var DepartmentPageGetServerSideProps = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
    var req, query, client, departmentSlug, _yield$client$query, data, department;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            req = _ref2.req, query = _ref2.query;
            client = new ServerGQLClient({
              uri: getEnvConfig().GRAPHQL_ENDPOINT,
              headers: req === null || req === void 0 ? void 0 : req.headers
            });
            departmentSlug = query.departmentSlug;
            _context.next = 5;
            return client.query({
              query: DepartmentDocument,
              variables: {
                input: {
                  slug: departmentSlug
                }
              }
            });

          case 5:
            _yield$client$query = _context.sent;
            data = _yield$client$query.data;
            department = data === null || data === void 0 ? void 0 : data.department;

            if (department) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", {
              notFound: true
            });

          case 10:
            return _context.abrupt("return", {
              props: {
                department: department
              }
            });

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function DepartmentPageGetServerSideProps(_x) {
    return _ref3.apply(this, arguments);
  };
}();